import Service from "../Service"

const dashboard = {

    // Research & Report
    getAllArticlePaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/article?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getArticle(data) {
        return Service.get(`/api/article/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createArticle(data) {
        return Service.post(`/api/article`, {
            name_th: data.name_th,
            name_en: data.name_en,
            intro_th: data.intro_th,
            intro_en: data.intro_en,
            detail_th: data.detail_th,
            detail_en: data.detail_en,
            report_create_date: data.report_create_date,
            indexmanage_id: data.indexmanage_id,
            tags: data.tag_id.toString(),
            industry_id: data.industry_id,
            image_cover_path: data.image_cover_path,
            image_share_path: data.image_share_path,
            is_display_overview: data.is_display_overview
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        })
    },

    editArticle(data) {
        return Service.put(`/api/article/${data.id}`, {
            name_th: data.name_th,
            name_en: data.name_en,
            intro_th: data.intro_th,
            intro_en: data.intro_en,
            detail_th: data.detail_th,
            detail_en: data.detail_en,
            report_create_date: data.report_create_date,
            indexmanage_id: data.indexmanage_id,
            tags: data.tag_id.toString(),
            industry_id: data.industry_id,
            image_cover_path: data.image_cover_path,
            image_share_path: data.image_share_path,
            is_display_overview: data.is_display_overview
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        })
    },

    deleteArticle(data) {
        return Service.delete(`/api/article/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // About
    getAboutDesc(data) {
        return Service.get(`/api/about`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },

    editAboutDesc(data) {
        return Service.put(`api/about/${data.id}`, {
            description_th: data.description_th,
            description_en: data.description_en
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        })
    }

};

export default dashboard;
